import { render } from "./MenuRow.vue?vue&type=template&id=1a996156&scoped=true"
import script from "./MenuRow.vue?vue&type=script&lang=js"
export * from "./MenuRow.vue?vue&type=script&lang=js"

import "./MenuRow.vue?vue&type=style&index=0&id=1a996156&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a996156"]])

export default __exports__